<template>
  <div>
    <div class="floral-bg-image"></div>
    <div class="center-container has-margin-top has-width">
      <div class="contact-us__header">
        <h1>{{ contactUsTitle }}</h1>
        <p>We are in the process of cataloging our stock.</p>
        <p>
          For the time being, please pop us an email below with a
          reference picture, and if we do not have it in stock we
          will source if for you.
        </p>
      </div>
      <div class="w-75 mx-auto">
        <div id="wufoo-m1lbke180wsj3wo">
          Fill out my <a href="https://berriesandblooms.wufoo.com/forms/m1lbke180wsj3wo">online form</a>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CatalogueForm',
  data: () => ({
    contactUsTitle: 'Coming Soon',
  }),
  metaInfo: {
    title: 'Berries and Blooms - Our Catalogue',
    links: [
      { rel: 'canonical', href: 'http://berriesandblooms.co.za/catalogue-form' },
      { rel: 'alternate', href: 'http://berriesandblooms.co.za/catalogue-form', hreflang: 'en-us' },
    ],
  },
  methods: {
    catalogueWufooForm () {
      /* eslint-disable */
      var m1lbke180wsj3wo;(function(d, t) {
      var s = d.createElement(t), options = {
        'userName':'berriesandblooms',
        'formHash':'m1lbke180wsj3wo',
        'autoResize':true,
        'height':'497',
        'async':true,
        'host':'wufoo.com',
        'header':'show',
        'ssl':true};

      s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js';
      s.onload = s.onreadystatechange = function () {
        var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return;
      try {
        m1lbke180wsj3wo = new WufooForm();
        m1lbke180wsj3wo.initialize(options);
        m1lbke180wsj3wo.display()
      } catch (e) {}};

      var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);
      })(document, 'script')
    }
  },
  mounted () {
    this.catalogueWufooForm()
  }
}
</script>

<style scoped lang="scss">
  @mixin form-styles($isTextarea: false) {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .06);
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, .2);
    font-size: 14px;
    padding: 10px 15px;
    width: 100%;

    &::placeholder {
      font-size: 12px;
      color: #ccc;
    }

    @if $isTextarea == true {
      margin: 8px 0 0;
      height: 150px;
    }
  }

  .popup-modal {
    background-color: white;
    border-radius: 3px;
    border: 1px solid rgba(0,0,0, .2);
    color: #463e5b;
    left: 50%;
    opacity: 0;
    padding: 60px 80px 55px;
    pointer-events: none;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 300ms ease-in;
    will-change: opacity;
    z-index: 10;

    &.isVisible {
      opacity: 1;
      pointer-events: auto;
    }

    .popup-modal__close {
      cursor: pointer;
      position: absolute;
      right: 30px;
      top: 30px;
      width: 15px;
    }

    > h4 {
      font-weight: 300;
      margin: 0 0 20px;
    }

    > p {
      font-size: 18px;
      font-weight: 700;
    }
  }

  .upload-form {
    max-width: 728px;
    margin: 0 auto;

    label {
      font-size: 14px;
      display: block;
      margin: 16px 0;
    }

    input {
      @include form-styles;
    }

    textarea {
      @include form-styles($isTextarea: true);
    }

    button {
      background-color: #463e5b;
      color: #fff;
      cursor: pointer;
      margin: 10px 0 0;
      padding: 10px 20px;
    }

    .upload-form--image-selected {
      font-size: 14px;
      margin: 5px 0 0 20px;
    }

    .form-buttons {
      display: flex;
      align-items: center;

      .upload-form--submit-btn {
        margin-left: auto;
      }
    }
  }
</style>
